export default __webpack_public_path__ + "static/media/Dashboard.eca6ac28.jpg";